const API_URL = process.env.REACT_APP_API_URL;

export const getManagers = async () => {
    try {
        const response = await fetch(`${API_URL}/Manager/GetManagers`);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching managers:', error);
        return {
            isSuccess: false,
            statusCode: 500,
            resultMessage: 'Bir hata oluştu',
            errors: [error.message],
            data: null
        };
    }
};

export const getManagerByGuid = async (guid) => {
    try {
        const response = await fetch(`${API_URL}/Manager/GetManagerDetail`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                guid: guid
            })
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching manager details:', error);
        return {
            isSuccess: false,
            statusCode: 500,
            resultMessage: 'Bir hata oluştu',
            errors: [error.message],
            data: null
        };
    }
};
